import * as React from 'react';
import { Menu, MenuItemLink, useResourceDefinitions } from 'react-admin';
import {
  AutoFixHigh as WizardIcon,
  Book as BookIcon,
  Category as CategoryIcon,
  Quiz as QuestionIcon,
  Quiz as QuizIcon,
  Assessment as ResultIcon,
  School as CourseIcon,
  Article as TemplateIcon,
  History as LogIcon,
  People as UsersIcon,
  PermMedia as MediaIcon,
  Reviews as ReviewsIcon
} from '@mui/icons-material';

const MyMenu = (props) => {
  const resources = useResourceDefinitions();

  // Define menu items with proper display names, icons, and order
  const menuItems = [
    { name: 'course_categories', displayName: 'Course Categories', icon: CategoryIcon },
    { name: 'course_questions', displayName: 'Course Questions', icon: QuestionIcon },
    { name: 'course_results', displayName: 'Course Results', icon: ResultIcon },
    { name: 'course_review_notes', displayName: 'Course Review Notes', icon: ReviewsIcon },
    { name: 'courses', displayName: 'Courses', icon: CourseIcon },
    { name: 'prompt_templates', displayName: 'Prompt Templates', icon: TemplateIcon },
    { name: 'media_files', displayName: 'Media Manager', icon: MediaIcon },
    { name: 'user_logs', displayName: 'User Logs', icon: LogIcon },
    { name: 'users', displayName: 'Users', icon: UsersIcon }
  ];

  return (
    <Menu {...props}>
      <Menu.DashboardItem />
      {/* Custom link to the new Course Wizard */}
      <MenuItemLink
        to="/course-material-wizard"
        primaryText="Course Wizard"
        leftIcon={<WizardIcon />}
      />
      {/* Custom link to the new Exam Wizard */}
      <MenuItemLink
        to="/exam-wizard"
        primaryText="Exam Wizard"
        leftIcon={<QuizIcon />}
      />
      {/* Custom link to Course Textbooks */}
      <MenuItemLink
        to="/course_material_content"
        primaryText="Course Textbooks"
        leftIcon={<BookIcon />}
      />
      {/* Render menu items in alphabetical order with proper names */}
      {menuItems
        .filter(item => resources[item.name]) // Only show if resource exists
        .map(item => (
          <Menu.ResourceItem key={item.name} name={item.name} />
        ))}
    </Menu>
  );
};

export default MyMenu;
